import BulkAddToTrashButton from "@/components/trash/BulkAddToTrashButton";
import TableSelectionActions, {
  TableSelectActionElements,
} from "@/components/table/TableSelectionActions";
import { RowSelectionState } from "@tanstack/react-table";
import { Dispatch, ReactNode, SetStateAction } from "react";

type DashboardSelectionBarProps = {
  documentType: string;
  selectionState: RowSelectionState;
  setSelectionState: Dispatch<SetStateAction<RowSelectionState>>;
  children?: TableSelectActionElements;
};

const DashboardSelectionBar = ({
  documentType,
  selectionState,
  setSelectionState,
  children,
}: DashboardSelectionBarProps) => {
  const clearSelection = () => setSelectionState({});

  return (
    <TableSelectionActions
      selectedRows={selectionState}
      setSelectedRows={setSelectionState}
      selectActions={(selectedIds) => (
        <SelectionActionsGroup>
          {children?.(selectedIds)}
          <BulkAddToTrashButton
            selectedIds={selectedIds}
            documentType={documentType}
            onSuccess={clearSelection}
          />
        </SelectionActionsGroup>
      )}
    />
  );
};

function SelectionActionsGroup({ children }: { children: ReactNode }) {
  return <div className="flex flex-row gap-3 items-center">{children}</div>;
}

export default DashboardSelectionBar;
